export default `/* Ids Action Sheet */
.ids-action-sheet-inner {
  align-items: center;
  background-color: var(--ids-action-sheet-color-background);
  border-color: var(--ids-action-sheet-color-border);
  display: flex;
  position: fixed;
  border-radius: var(--ids-action-sheet-border-radius);
  flex-direction: column;
  width: 100%;
  bottom: var(--ids-space-none);
  left: 50%;
  transform: translate(-50%, 100%);
  padding-block: var(--ids-action-sheet-padding);
  border-bottom-left-radius: var(--ids-border-radius-none);
  border-bottom-right-radius: var(--ids-border-radius-none);
  box-shadow: var(--ids-action-sheet-shadow);
  transition: transform var(--ids-motion-duration) var(--ids-motion-ease);
}

:host([visible=true]) .ids-action-sheet-inner {
  transform: translate(-50%, 0);
}

::slotted(ids-menu) {
  width: 100%;
}

ids-button {
  width: calc(100% - var(--ids-space-xs) * 3);
  margin-block-start: var(--ids-space-xs);
}
ids-button span {
  display: block;
  width: 100%;
  text-align: center;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL2J1aWxkcy9pbmZvci1kZXNpZ24vZW50ZXJwcmlzZS13Yy9zcmMvY29tcG9uZW50cy9pZHMtYWN0aW9uLXNoZWV0Iiwic291cmNlcyI6WyJpZHMtYWN0aW9uLXNoZWV0LnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7QUFDQTtFQUNFO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBOzs7QUFJQTtFQUNFOzs7QUFJSjtFQUNFOzs7QUFHRjtFQUNFO0VBQ0E7O0FBRUE7RUFDRTtFQUNBO0VBQ0EiLCJzb3VyY2VzQ29udGVudCI6WyIvKiBJZHMgQWN0aW9uIFNoZWV0ICovXG4uaWRzLWFjdGlvbi1zaGVldC1pbm5lciB7XG4gIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gIGJhY2tncm91bmQtY29sb3I6IHZhcigtLWlkcy1hY3Rpb24tc2hlZXQtY29sb3ItYmFja2dyb3VuZCk7XG4gIGJvcmRlci1jb2xvcjogdmFyKC0taWRzLWFjdGlvbi1zaGVldC1jb2xvci1ib3JkZXIpO1xuICBkaXNwbGF5OiBmbGV4O1xuICBwb3NpdGlvbjogZml4ZWQ7XG4gIGJvcmRlci1yYWRpdXM6IHZhcigtLWlkcy1hY3Rpb24tc2hlZXQtYm9yZGVyLXJhZGl1cyk7XG4gIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW47XG4gIHdpZHRoOiAxMDAlO1xuICBib3R0b206IHZhcigtLWlkcy1zcGFjZS1ub25lKTtcbiAgbGVmdDogNTAlO1xuICB0cmFuc2Zvcm06IHRyYW5zbGF0ZSgtNTAlLCAxMDAlKTtcbiAgcGFkZGluZy1ibG9jazogdmFyKC0taWRzLWFjdGlvbi1zaGVldC1wYWRkaW5nKTtcbiAgYm9yZGVyLWJvdHRvbS1sZWZ0LXJhZGl1czogdmFyKC0taWRzLWJvcmRlci1yYWRpdXMtbm9uZSk7XG4gIGJvcmRlci1ib3R0b20tcmlnaHQtcmFkaXVzOiB2YXIoLS1pZHMtYm9yZGVyLXJhZGl1cy1ub25lKTtcbiAgYm94LXNoYWRvdzogdmFyKC0taWRzLWFjdGlvbi1zaGVldC1zaGFkb3cpO1xuICB0cmFuc2l0aW9uOiB0cmFuc2Zvcm0gdmFyKC0taWRzLW1vdGlvbi1kdXJhdGlvbikgdmFyKC0taWRzLW1vdGlvbi1lYXNlKTtcbn1cblxuOmhvc3QoW3Zpc2libGU9J3RydWUnXSkge1xuICAuaWRzLWFjdGlvbi1zaGVldC1pbm5lciB7XG4gICAgdHJhbnNmb3JtOiB0cmFuc2xhdGUoLTUwJSwgMCk7XG4gIH1cbn1cblxuOjpzbG90dGVkKGlkcy1tZW51KSB7XG4gIHdpZHRoOiAxMDAlO1xufVxuXG5pZHMtYnV0dG9uIHtcbiAgd2lkdGg6IGNhbGMoMTAwJSAtIGNhbGModmFyKC0taWRzLXNwYWNlLXhzKSAqIDMpKTtcbiAgbWFyZ2luLWJsb2NrLXN0YXJ0OiB2YXIoLS1pZHMtc3BhY2UteHMpO1xuXG4gIHNwYW4ge1xuICAgIGRpc3BsYXk6IGJsb2NrO1xuICAgIHdpZHRoOiAxMDAlO1xuICAgIHRleHQtYWxpZ246IGNlbnRlcjtcbiAgfVxufVxuIl19 */`;
